import { render } from "./recordList.vue?vue&type=template&id=5f2a4693&scoped=true"
import script from "./recordList.vue?vue&type=script&lang=js"
export * from "./recordList.vue?vue&type=script&lang=js"

import "./recordList.vue?vue&type=style&index=0&id=5f2a4693&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f2a4693"]])

export default __exports__